import { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";
import { FaWhatsapp } from "react-icons/fa";
import { DEFAULT_WA_URL } from "@/lib/whatsapp";
import { scrollToTop } from "@/lib/scroll";
import { AnimatePresence, motion } from "framer-motion";

export const FloatingActions = () => {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 500);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div className="fixed bottom-24 right-5 z-[60] flex flex-col items-end gap-3">
      <AnimatePresence>
        {showTop && (
          <motion.button
            data-testid="back-to-top-button"
            aria-label="Back to top"
            onClick={scrollToTop}
            initial={{ opacity: 0, scale: 0.8, y: 10 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.8, y: 10 }}
            transition={{ duration: 0.2 }}
            className="grid h-11 w-11 place-items-center rounded-full border border-[var(--border-hover)] bg-[rgba(22,22,22,0.85)] text-[var(--accent-secondary)] backdrop-blur transition-colors hover:bg-[rgba(42,34,24,0.95)] focus-ring"
          >
            <ArrowUp size={18} />
          </motion.button>
        )}
      </AnimatePresence>

      <a
        data-testid="floating-whatsapp-button"
        href={DEFAULT_WA_URL}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat on WhatsApp"
        className="anim-wapulse grid h-14 w-14 place-items-center rounded-full bg-[#25D366] text-white shadow-[0_10px_30px_rgba(0,0,0,0.35)] transition-transform duration-200 hover:scale-110 focus-ring"
      >
        <FaWhatsapp size={28} />
      </a>
    </div>
  );
};
